import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from '../../constants';


const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const FETCH_RECURLY_TOKEN = createApiNamespacedConstants('FETCH_RECURLY_TOKEN');
export const RECURLY_COMPONENT_FETCH = `${NAMESPACE}/RECURLY_COMPONENT_FETCH`;
export const RECURLY_COMPONENT_READY = `${NAMESPACE}/RECURLY_COMPONENT_READY`;
export const PAYMENT_INFO_SAVED = `${NAMESPACE}/PAYMENT_INFO_SAVED`;
export const PAYMENT_METHOD_CHANGED = `${NAMESPACE}/PAYMENT_METHOD_CHANGED`;
export const INITIALIZE = `${NAMESPACE}/INITIALIZE`;
export const SAVE_COUPON_CODE = `${NAMESPACE}/SAVE_COUPON_CODE`;
export const RESET_COUPON_CODE = `${NAMESPACE}/RESET_COUPON_CODE`;

export const CHECKOUT_PREVIEW = createApiNamespacedConstants('CHECKOUT_PREVIEW');
export const CHECKOUT_PURCHASE = createApiNamespacedConstants('CHECKOUT_PURCHASE');
export const FETCH_ACCOUNT = createApiNamespacedConstants('FETCH_ACCOUNT');
export const UPDATE_ACCOUNT = createApiNamespacedConstants('UPDATE_ACCOUNT');
export const UPDATE_BILLING_INFO = createApiNamespacedConstants('UPDATE_BILLING_INFO');
